import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
let VueSlider = {};

if (process.browser) {
  // eslint-disable-next-line
  VueSlider = require('vue-slider-component');
}

export default {
  name: 'CategoryDimensionsFilter',
  components: {
    VueSlider
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      model: {
        depth: this.getInitialDimensionValue('depth'),
        width: this.getInitialDimensionValue('width'),
        height: this.getInitialDimensionValue('height')
      }
    };
  },

  computed: {
    tracking() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Filtre_Taille',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    }

  },
  watch: {
    filter() {
      this.model = {
        depth: this.getInitialDimensionValue('depth'),
        width: this.getInitialDimensionValue('width'),
        height: this.getInitialDimensionValue('height')
      };
    }

  },
  methods: _objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY'
  }), {
    handleInput(facet, event) {
      if (!this.model[facet.dimension]) {
        return;
      }

      this.filterBy({
        filter: facet.dimension,
        facet: "0-".concat(parseInt(this.model[facet.dimension], 10)),
        uniq: true
      });
      this.$root.$emit('generic-tracking', event, this.tracking);
    },

    generateSilderOptions(facet) {
      return {
        height: 2,
        silent: true,
        enableCross: false,
        dotSize: 25,
        min: parseFloat(parseFloat(facet.min, 10).toFixed(2), 10),
        max: parseFloat(parseFloat(facet.max, 10).toFixed(2), 10),
        interval: 0.01,
        lazy: true,
        tooltip: 'none',
        processStyle: {
          backgroundColor: '#c4a181'
        },
        railStyle: {
          backgroundColor: '#9B9B9B'
        }
      };
    },

    dotText(dimension) {
      return this.model[dimension] ? parseInt(this.model[dimension], 10) : '';
    },

    getInitialDimensionValue(dimension) {
      let selectedValue;
      let defaultValue;

      switch (dimension) {
        case 'depth':
          selectedValue = this.filter.facets[0].selected ? parseFloat(this.filter.facets[0].selected.max, 10) : null;
          defaultValue = parseFloat(this.filter.facets[0].max, 10);
          return selectedValue && selectedValue < defaultValue ? selectedValue : defaultValue;

        case 'width':
          selectedValue = this.filter.facets[1].selected ? parseFloat(this.filter.facets[1].selected.max, 10) : null;
          defaultValue = parseFloat(this.filter.facets[1].max, 10);
          return selectedValue && selectedValue < defaultValue ? selectedValue : defaultValue;

        case 'height':
          selectedValue = this.filter.facets[2].selected ? parseFloat(this.filter.facets[2].selected.max, 10) : null;
          defaultValue = parseFloat(this.filter.facets[2].max, 10);
          return selectedValue && selectedValue < defaultValue ? selectedValue : defaultValue;

        default:
          return 0;
      }
    }

  })
};